<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h4 class="heading semi-bold float-left">Scan Fabric For Product Order</h4>
      </div>
      <div class="grid-body">
        <div class="row">
          <div class="col-md-12">
            <div class="alert alert-primary" role="alert">
              <strong
                >Currently Default Unit for Length is In Centimeters
                (cm)</strong
              >
            </div>
          </div>
        </div>
        <div class="row">
          <form @submit.prevent="scanFabric()">
            <div class="col-md-12">
              <div class="alert alert-danger" role="alert" v-if="error">
                <strong>{{ error }}</strong>
              </div>
            </div>
            <div class="col-md-12">
              <toggle-button v-model="manual" /> Manual<br /><br />

              <div class="row mt-15" v-if="manual">
                <label>Select Fabric</label>
                <v-select
                  :options="allFabrics"
                  v-model="selectedFabricId"
                  label="production_name"
                  :reduce="(allFabrics) => allFabrics.id"
                  placeholder="Choose One"
                />
              </div>

              <div class="row mt-15" v-if="manual">
                <div class="form-group">
                  <label for="">Length</label>
                  <numkeyboard
                    expose-elem="selector"
                    v-model="length"
                    ok-text="OK"
                    text-align="left"
                  ></numkeyboard>
                </div>
              </div>

              <input
                type="text"
                v-model="barcode"
                placeholder="Product Order ID"
                class="form-control scan-shirt"
              />

              <br />
              <button type="submit" class="btn btn-success btn-block">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="grid-body">
        <h1 class="text-bold message">{{ message }}</h1>
        <br /><br />
      </div>
    </div>
    <div class="loading">
      <i class="fa fa-circle-o-notch fa-spin"></i>
    </div>
  </div>
</template>

<script>
import numpad from "jquery.numpad";
export default {
  data() {
    return {
      barcode: null,
      message: null,
      manual: false,
      allFabrics: [],
      selectedFabricId: null,
      length: "",
      error: null,
      stillCut: false,
    };
  },
  watch: {
    manual: function () {
      this.initKeyPad();
    },
  },
  mounted() {
    $(".scan-shirt").focus();
    this.getFabrics();
    this.initKeyPad();
  },
  methods: {
    initKeyPad() {
      if (this.manual) {
        setTimeout(() => {
          $(".nmpd-wrapper").hide();
          $("#selector1").numpad();
        }, 200);
      }
    },

    async getFabrics() {
      let results = await axios({
        method: "get",
        url: "/v2/fabrics?as_dropdown=1",
      });
      this.allFabrics = results.data.data.collection;
    },

    async scanFabric() {
      this.message = this.barcode;
      try {
        let response = null;

        if (this.manual) {
          if (!this.length) {
            this.error = "Please Input Length";
            return false;
          } else if (!this.barcode) {
            this.error = "Please Scan Shirt Order Id";
            return false;
          } else {
            $(".loading").show();
            this.error = null;
            response = await axios.post("fabrics/scan", {
              product_order_id: this.barcode,
              length: this.length * 1,
              auto: false,
              type: "product_order",
              fabric_id: this.selectedFabricId,
              still_cut: this.stillCut,
            });
          }
        } else {
          if (!this.barcode) {
            this.error = "Please Scan Shirt Order Id";
            return false;
          } else {
            this.error = null;
            $(".loading").show();
            response = await axios.post("fabrics/scan", {
              product_order_id: this.barcode,
              auto: true,
              type: "product_order",
              still_cut: this.stillCut,
            });
          }
        }

        if (response.data) {
          const result = response.data.result;
          Swal.fire({
            type: "info",
            title: "Scan Successful",
            html:
              "Order Number : " + result.order + "<br/>" +
              "Amount of Cut: " + parseFloat(result.cut_length).toFixed(2) +  "m<br/>" +
              "Roll width   : " + result.roll_width + "<br/>" + 
              "Items cut    : " + result.item_count + "<br/>" + 
              "Error        : " + result.error_message
          });
        }

        this.barcode = null;
        this.stillCut = false;
        this.length = "";
        $("#selector1").val("");
        toastr.success("Success");
        $(".loading").hide();
      } catch (error) {
        $(".loading").hide();
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          let message =
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : "Something Went Wrong. Please Try Again!";

          message = message.split("&&");

          if (message[0] === "not_enough") {
            let fabric_id = message[1];
            Swal.fire({
              title: "Warning",
              text: "Roll Should Be Empty",
              type: "warning",
              showCloseButton: true,
              showCancelButton: true,
              cancelButtonColor: "#3085d6",
              confirmButtonColor: "#ff5252",
              confirmButtonText: "Still Cut",
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              cancelButtonText: "Withdraw New Roll",
            }).then((result) => {
              if (result.dismiss === "cancel") {
                this.$router.push("/fabric/roll/withdraw/" + fabric_id);
              } else if (result.value) {
                this.stillCut = true;
                this.scanFabric();
              }
            });
          } else {
            Swal.fire("ERROR", message[0], "error");
            this.barcode = null;
          }
        }
      }
    },
  },
};
</script>

<style scoped>
.scan-shirt {
  font-size: 90px !important;
  height: 200px;
}
.btn-lg {
  height: 50px;
  font-size: 25px;
}
.loading {
  font-size: 150px;
  position: absolute;
  top: 20%;
  text-align: center;
  width: 100%;
  left: 0px;
  right: 0px;
  display: none;
}
.message {
  font-size: 90px;
}
</style>
